(() => {
  const preferenceKey = 'outlaw_country_manual_v1';
  const checkedKey = 'outlaw_country_checked_v1';
  const configElement = document.getElementById('outlaw-auto-country-config');
  const form = document.getElementById('OutlawAutoCountryForm');
  if (!configElement || !form) return;

  const config = JSON.parse(configElement.textContent);
  if (config.designMode || /bot|crawler|spider|lighthouse/i.test(navigator.userAgent)) return;

  const read = (key, storage) => {
    try { return storage.getItem(key); } catch { return null; }
  };
  const write = (key, value, storage) => {
    try { storage.setItem(key, value); return true; } catch { return false; }
  };
  const local = (() => { try { return window.localStorage; } catch { return null; } })();
  const session = (() => { try { return window.sessionStorage; } catch { return null; } })();
  const remember = (country) => {
    if (!config.available.includes(country)) return;
    write(preferenceKey, country, local);
    write(preferenceKey, country, session);
  };
  window.addEventListener('outlaw:country-selected', (event) => remember(event.detail?.country));
  document.addEventListener('submit', (event) => {
    if (event.target === form || !(event.target instanceof HTMLFormElement)) return;
    const country = new FormData(event.target).get('country_code');
    if (typeof country === 'string') remember(country);
  }, true);

  const params = new URLSearchParams(window.location.search);
  if (params.has('country')) {
    remember(params.get('country')?.toUpperCase());
    return;
  }
  if (read(preferenceKey, local) || read(preferenceKey, session) || read(checkedKey, session)) return;
  if (!write(checkedKey, '1', session)) return;

  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 3000);
  const url = new URL(config.root + 'browsing_context_suggestions.json', window.location.origin);
  url.searchParams.set('country[enabled]', 'true');
  url.searchParams.set('language[enabled]', 'false');

  fetch(url, { credentials: 'same-origin', signal: controller.signal })
    .then((response) => response.ok ? response.json() : null)
    .then((result) => {
      const country = result?.detected_values?.country?.handle;
      if (read(preferenceKey, local) || read(preferenceKey, session)) return;
      if (!['AU', 'US'].includes(country) || !config.available.includes(country) || country === config.country) return;
      const returnUrl = new URL(window.location.href);
      returnUrl.searchParams.delete('country');
      form.elements.country_code.value = country;
      form.elements.return_to.value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
      HTMLFormElement.prototype.submit.call(form);
    })
    .catch(() => {})
    .finally(() => window.clearTimeout(timeout));
})();
